// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { InventoryEntry } from '@/inventory/api/types';

/**
 * Names one location's stock under its site: the site's own floor, an archived zone, or the zone
 */
export function toZoneName(entry: InventoryEntry, siteId: string): string {
  if (entry.location.id === siteId) {
    return 'Default zone';
  }

  if (entry.location.isArchived) {
    return 'Archived zone';
  }

  return entry.location.name;
}
